import { RCBanner } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import DocumentBrandIcon from '@reverbdotcom/cadence/images/brand/document-orange.svg';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { COUNTRY_CODES } from '../shared/constants';

const COUNTRY_CODE_TO_TITLE_MAPPING = {
  [COUNTRY_CODES.AU]: 'auTaxTitle',
  [COUNTRY_CODES.UK]: 'ukTaxTitle',
};

const COUNTRY_CODE_TO_CONTENT_MAPPING = {
  [COUNTRY_CODES.AU]: 'auAndUkContent',
  [COUNTRY_CODES.UK]: 'auAndUkContent',
};

interface Props {
  taxType: string;
  countryCode: string;
}

export function InternationalTaxIdBanner({ taxType, countryCode }: Props) {
  const titleKey = COUNTRY_CODE_TO_TITLE_MAPPING[countryCode];
  const contentKey = COUNTRY_CODE_TO_CONTENT_MAPPING[countryCode] || 'euAddTaxId';

  return (
    <RCBanner
      title={titleKey ? I18n.t(`discovery.internationalTaxIds.banner.${titleKey}`) : ''}
      content={
        <Translate text={`discovery.internationalTaxIds.banner.${contentKey}`}>
          <Translate text={`discovery.internationalTaxIds.banner.${taxType}`} />
        </Translate>
      }
      image={DocumentBrandIcon}
      cta={<CoreLink to="/my/selling/tax_policy"><Translate text="discovery.internationalTaxIds.banner.buttonText" /></CoreLink>}
    />
  );
}

export default InternationalTaxIdBanner;
